import {type QuoteResource} from '@api';
import {isQuoteTimeAndMaterials} from './quote.guards';

export function feesPerWorkUnit(quote?: QuoteResource | null): number {
    if (isQuoteTimeAndMaterials(quote)) {
        if (quote.details.estimatedTotalWorkAmount) {
            return quote.amounts.feesAmountExcludingTaxes / quote.details.estimatedTotalWorkAmount;
        }
        return 0;
    } else return 0;
}

export function clientWorkRate(quote?: QuoteResource | null): number {
    if (isQuoteTimeAndMaterials(quote)) {
        return quote.details.workRate.value + feesPerWorkUnit(quote);
    } else return 0;
}

export function estimatedMonthlyPayment(quote?: QuoteResource | null): number {
    if (isQuoteTimeAndMaterials(quote) && quote.details.estimatedTotalLots > 0) {
        return quote.amounts.totalAmountExcludingTaxes / quote.details.estimatedTotalLots;
    }
    return 0;
}
